import { Observable, OperatorFunction } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ActionCreator, AnyAction, Meta } from 'typescript-fsa';
import { IParamsAndResolver } from '../_interfaces/IParamsAndResolver';

const getFunctionFromMeta = (meta: Meta, fnName: string): VoidFunction => {
  return meta && Object.hasOwn(meta, fnName) && meta[fnName] instanceof Function ? meta[fnName] : undefined;
};

export function isTypeOfAndGetParamsAndResolver<R>(
  actionFactory: ActionCreator<R>,
): OperatorFunction<AnyAction, IParamsAndResolver<R>> {
  function isTypeOfAndGetPayloadOperation(source: Observable<AnyAction>) {
    return source.pipe(
      filter(actionFactory.match),
      map((action) => {
        const { payload, meta } = action;

        return {
          params: payload,
          resolve: getFunctionFromMeta(meta, 'resolve'),
          reject: getFunctionFromMeta(meta, 'reject'),
        };
      }),
    );
  }

  return isTypeOfAndGetPayloadOperation;
}
